import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ResponsiveX } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import PolicyRowM from "./_gears/PolicyRowM";
import PolicyRowW from "./_gears/PolicyRowW";

/**
 * @augments {Component<Props, State>}
 */
class PolicyRow extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PolicyRow.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  render(){
    return ResponsiveX.Split({
      0: () => <PolicyRowM {...this.props} />,
      560: () => <PolicyRowW {...this.props} />
    });
  }

}

export default observer(PolicyRow);
